import { render } from "./single-breadcrumb.vue?vue&type=template&id=0b5848c2"
import script from "./single-breadcrumb.vue?vue&type=script&lang=js"
export * from "./single-breadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__